var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.470703,
    width: 30.53,
    height: 30,
    rx: 8,
    fill: "#F3F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0441 10.5841L15.7353 13.893L12.4264 10.5841C12.1234 10.2811 11.6224 10.2811 11.3194 10.5841C11.0164 10.8871 11.0164 11.3882 11.3194 11.6911L14.6282 15L11.3194 18.3089C11.0164 18.6118 11.0164 19.1129 11.3194 19.4159C11.6224 19.7189 12.1234 19.7189 12.4264 19.4159L15.7353 16.107L19.0441 19.4159C19.3471 19.7189 19.8482 19.7189 20.1511 19.4159C20.4541 19.1129 20.4541 18.6118 20.1511 18.3089L16.8423 15L20.1511 11.6911C20.4541 11.3882 20.4541 10.8871 20.1511 10.5841C19.8482 10.2811 19.3471 10.2811 19.0441 10.5841Z",
    fill: "#212121",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/CloseButton.dd9e82ad49bcfb74b64987d1cc2fc186.svg";
export { ForwardRef as ReactComponent };